import React from 'react'
import SvgIcon from '@material-ui/core/SvgIcon/SvgIcon'
import { SvgIconProps } from '@material-ui/core'

/**
 * Figma link: https://www.figma.com/file/3z9SovcAVVWRw6bR0jPFLc/UI_library_2.0?node-id=8735%3A20730
 *
 * @param {SvgIconProps} props - svg props
 */
export const SendEmailIcon = (props: SvgIconProps): JSX.Element => {
    const color = props.color || 'currentColor'
    const svgProps = Object.assign({}, props)
    delete svgProps.color
    return (
        <SvgIcon {...svgProps} width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path fillRule='evenodd' clipRule='evenodd' d='M0 3.60985C0 3.27304 0.273041 3 0.609854 3H17.8901C18.227 3 18.5 3.27304 18.5 3.60985C18.5 3.72395 18.4363 3.8285 18.3349 3.88082L10.1672 8.09603C9.5918 8.39299 8.9082 8.39299 8.33278 8.09603L0.165085 3.88082C0.0636956 3.8285 0 3.72395 0 3.60985ZM0 5.02361C0 4.61784 0.45786 4.38106 0.788991 4.61559L8.09404 9.78953C8.78662 10.2801 9.71338 10.2801 10.406 9.78953L17.711 4.61559C18.0421 4.38106 18.5 4.61784 18.5 5.02361V11.6223L11.8039 10.4999L13.713 13.9456C8.547 16.8088 5.48134 15.9766 1.30331 14.5C1.89978 15.1451 2.54292 15.8394 3.2415 16.5255H1C0.447716 16.5255 0 16.0778 0 15.5255V5.02361Z' fill={color}/>
            <path d='M18.9308 19.492L20.4545 22.1441L23.8335 14.3043L15.1215 12.8617L16.6833 15.5801C12.3651 17.8648 8.7328 18.4032 5.24044 17.225C8.00872 20.0832 12.5043 22.0275 18.9308 19.492Z' fill={color}/>
        </SvgIcon>
    )
}

export default SendEmailIcon
